export default __webpack_public_path__ + "static/projektmanagement-514877be5fe70807ae716323cb674c45.webp";